
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Search, ArrowRight } from "lucide-react";
import { appStoreCatalog, macOSCatalog } from "@/data/mockApps";


interface ApplicationCatalogProps {
  onSelectApp: (id: string, source: 'appStore' | 'macOSCatalog') => void;
}

export const ApplicationCatalog = ({ onSelectApp }: ApplicationCatalogProps) => {
  const [searchTerm, setSearchTerm] = useState("");
  
  const filteredAppStoreCatalog = appStoreCatalog.filter(app => 
    app.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  const filteredMacOSCatalog = macOSCatalog.filter(app => 
    app.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="space-y-6">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input 
          className="pl-9" 
          placeholder="Search apps by name" 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <Tabs defaultValue="appStore" className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="appStore">App Store</TabsTrigger>
          <TabsTrigger value="macOSCatalog">macOS Catalog</TabsTrigger>
        </TabsList>
        <TabsContent value="appStore" className="mt-4">
          {filteredAppStoreCatalog.length > 0 ? (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Application</TableHead>
                  <TableHead className="text-right">Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {filteredAppStoreCatalog.map(app => (
                  <TableRow 
                    key={app.id}
                    className="cursor-pointer"
                    onClick={() => onSelectApp(app.id, 'appStore')}
                  >
                    <TableCell>
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded overflow-hidden flex-shrink-0">
                          <img src={app.icon} alt={app.name} className="w-full h-full object-cover" />
                        </div>
                        <span className="font-medium">{app.name}</span>
                      </div>
                    </TableCell>
                    <TableCell className="text-right">
                      <Button variant="ghost" size="sm">
                        <ArrowRight className="h-4 w-4" />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <div className="text-center py-8 text-muted-foreground">
              No apps found matching "{searchTerm}"
            </div>
          )}
        </TabsContent>
        <TabsContent value="macOSCatalog" className="mt-4">
          {filteredMacOSCatalog.length > 0 ? (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Application</TableHead>
                  <TableHead className="text-right">Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {filteredMacOSCatalog.map(app => (
                  <TableRow 
                    key={app.id}
                    className="cursor-pointer"
                    onClick={() => onSelectApp(app.id, 'macOSCatalog')}
                  >
                    <TableCell>
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded overflow-hidden flex-shrink-0">
                          <img src={app.icon} alt={app.name} className="w-full h-full object-cover" />
                        </div>
                        <span className="font-medium">{app.name}</span>
                      </div>
                    </TableCell>
                    <TableCell className="text-right">
                      <Button variant="ghost" size="sm">
                        <ArrowRight className="h-4 w-4" />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <div className="text-center py-8 text-muted-foreground">
              No apps found matching "{searchTerm}"
            </div>
          )}
        </TabsContent>
      </Tabs>
    </div>
  );
};
